export const IconList = [
  "upload-file-rounded",
  "home-filled",
  "home-outlined",
  "description-filled",
  "description-outlined",
  "remove-shopping-cart-filled",
  "remove-shopping-cart-outlined",
  "support-agent-filled",
  "support-agent-outlined",
  "dashboard-outlined",
  "trending-up",
  "monetization-on-outlined",
  "call-outlined",
  "headphones",
  "calendar",
  "add-circle-outlined",
  "add-circle-filled",
  "check-circle",
  "check-circle-outline",
  "check",
  "error",
  "error-outline",
  "warning",
  "warning-amber",
  "close",
  "chevron-left",
  "chevron-right",
  "edit",
  "connect",
  "copy",
  "loading",
] as const;

export type IconName = (typeof IconList)[number];

export interface AtIconProps {
  /** The name of the icon to display */
  name: IconName;
  /** Additional CSS classes */
  className?: string;
  /** Size of the icon - can be predefined size, custom numeric value, or CSS units for responsive */
  size?: "small" | "medium" | "large" | number | string;
}
